import React, { useState, useEffect } from "react";

const LoaderAnimation = () => {
  const [colors, setColors] = useState([
    "#82005d",
    "#f99c01",
    "#00ebdc",
    "#ff4c01",
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setColors((prevColors) => {
        const newColors = [...prevColors];
        newColors.push(newColors.shift());
        return newColors;
      });
    }, 400);

    return () => clearInterval(interval);
  }, []);

  const boxStyle = {
    minWidth: "3rem",
    minHeight: "3rem",
    borderRadius: "2rem",
  };

  return (
    <section className=" d-flex justify-content-center align-items-center">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          border: "8px solid #ff4c01",
          padding: "1rem",
          borderRadius: "2rem",
        }}
      >
        {colors.map((color, index) => (
          <div
            key={index}
            style={{
              ...boxStyle,
              background: color,
            }}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default LoaderAnimation;
